<template>
  <section class="trade-page ypage-box">
    <AppHeader />

    <div class="trade-content">
      <div class="trade-tabs">
        <button type="button" class="tab-item" :class="{ active: action.active === 0 }" @click="switchTab(0)">{{ $quote }}</button>
        <button type="button" class="tab-item" :class="{ active: action.active === 1 }" @click="switchTab(1)">TRX</button>
        <button type="button" class="tab-item" :class="{ active: action.active === 3 }" @click="switchTab(3)">{{ $t('withdraw') }}</button>
      </div>

      <p v-if="message" class="msg">{{ message }}</p>

      <div v-if="action.active === 0 || action.active === 1" class="actions-con box-shadow20">
        <button type="button" class="records-btn" @click="$router.push('/records')">
          <svg class="record-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 3h8l4 4v14H7zM15 3v4h4M10 11h6M10 15h6M10 19h4" />
          </svg>
          <span>{{ $t('records') }}</span>
        </button>

        <h3 class="card-title">{{ $t('exchange') }}</h3>

        <div class="input-wrap">
          <div class="flex-wrap">
            <span class="prefix">{{ $t('from') }}</span>
            <div class="field">
              <input
                v-model="sourceValue"
                type="text"
                class="amount-input"
                :placeholder="`${$t('available')} ${numFormat(sourceAvailable, 6)}`"
              />
            </div>
            <button type="button" class="all-btn" @click="fillAllCurrent">{{ $t('all') }}</button>
            <div class="coin-wrap">
              <img class="coin-icon" :src="sourceIcon" :alt="sourceCoin" />
              <span>{{ sourceCoin }}</span>
            </div>
          </div>
        </div>

        <div class="speator">↓</div>

        <div class="input-wrap">
          <div class="flex-wrap">
            <span class="prefix">{{ $t('to') }}</span>
            <div class="field">
              <input :value="destinationValue" type="text" class="amount-input disabled" disabled />
            </div>
            <div class="coin-wrap">
              <img class="coin-icon" src="/recovered-assets/usdt_logo.png" alt="USDT" />
              <span>USDT</span>
            </div>
          </div>
        </div>

        <div class="price-text">{{ $t('price') }}: {{ priceText }}</div>
      </div>

      <div v-if="action.active === 3" class="actions-con box-shadow20">
        <button type="button" class="records-btn" @click="$router.push('/records')">
          <svg class="record-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 3h8l4 4v14H7zM15 3v4h4M10 11h6M10 15h6M10 19h4" />
          </svg>
          <span>{{ $t('records') }}</span>
        </button>

        <h3 class="card-title">{{ $t('withdraw') }}</h3>

        <div class="input-wrap">
          <div class="flex-wrap">
            <span class="prefix">{{ $t('amount') }}</span>
            <div class="field">
              <input
                v-model="action.withdrawValue"
                type="text"
                class="amount-input"
                :maxlength="amountLength"
                :placeholder="`${$t('available')} ${numFormat(withdrawAvailable, 6)}`"
              />
            </div>
            <button type="button" class="all-btn" @click="onTotalBalance">{{ $t('all') }}</button>
            <div class="coin-wrap">
              <img class="coin-icon" src="/recovered-assets/usdt_logo.png" alt="USDT" />
              <span>USDT</span>
            </div>
          </div>
        </div>

        <div class="fee-tip">{{ $t('fee') }}: {{ calcWithdrawFee }} USDT ({{ withdrawFeePercent }}%)</div>
      </div>

      <div v-if="action.active === 2" class="actions-con box-shadow20">
        <h3 class="card-title">{{ $t('usdtToContract') }}</h3>
        <div class="input-wrap">
          <div class="flex-wrap">
            <span class="prefix">{{ $t('amount') }}</span>
            <div class="field">
              <input
                v-model="action.exchangeContract"
                type="text"
                class="amount-input"
                :placeholder="`${$t('available')} ${numFormat(exchangeContractUSDTAvailable, 6)}`"
              />
            </div>
            <button type="button" class="all-btn" @click="onTotalUsdt">{{ $t('all') }}</button>
            <div class="coin-wrap">
              <img class="coin-icon" src="/recovered-assets/usdt_logo.png" alt="USDT" />
              <span>USDT</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="action.active === 0 || action.active === 1" class="switch-line">
        <label class="switch">
          <input :checked="checked" type="checkbox" @change="onToggleAutoExchange" />
          <span class="slider"></span>
        </label>
      </div>

      <button type="button" class="submit-btn" :disabled="btnLoading" @click="onSubmit">
        {{ action.active === 3 ? $t('withdraw') : $t('exchange') }}
      </button>

      <p v-if="action.active === 0 || action.active === 1" class="hint">
        {{ $t('autoHint') }}
      </p>
    </div>

    <MobileTabBar current="withdraw" />
  </section>
</template>

<script>
import { getUserInfo } from "../recovered/sign-api";
import {
  getConfig,
  getUserAssets,
  orderExchange,
  orderWithdraw,
  exchangeContractByUSDT,
  changeAutoExchange,
} from "../recovered/trade-api";
import MobileTabBar from "../components/MobileTabBar.vue";
import LangSwitch from "../components/LangSwitch.vue";
import QuoteSelect from "../components/QuoteSelect.vue";
import AppHeader from "../components/AppHeader.vue";
import BrandLogo from "../components/BrandLogo.vue";

function toNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export default {
  name: "TradeView",
  components: {
    MobileTabBar,
    LangSwitch,
    QuoteSelect,
    AppHeader,
    BrandLogo,
  },
  i18n: {
    zh: {
      withdraw: "提取",
      exchange: "交换",
      records: "记录",
      from: "从",
      to: "至",
      all: "全部",
      available: "可用的",
      price: "价格",
      fee: "手续费",
      amount: "数量",
      usdtToContract: "USDT 转合约",
      autoHint: "开启自动转账后，矿池收益会自动兑换成USDT",
      autoExchangeFailed: "切换自动兑换失败",
      getConfigFailed: "获取配置失败",
      getUserInfoFailed: "获取用户信息失败",
      getUserAssetsFailed: "获取用户资产失败",
      invalidEthAmount: "无效的 USDC 数量",
      insufficientEthBalance: "USDC 余额不足",
      ethExchangeSucceeded: "USDC 兑换成功",
      invalidTrxAmount: "无效的 TRX 数量",
      insufficientTrxBalance: "TRX 余额不足",
      trxExchangeSucceeded: "TRX 兑换成功",
      invalidWithdrawAmount: "无效的提取数量",
      insufficientUsdtBalance: "USDT 余额不足",
      amountMustBeGte: "数量必须 >=",
      amountMustBeLte: "数量必须 <=",
      withdrawSucceeded: "提取成功",
      invalidUsdtAmount: "无效的 USDT 数量",
      insufficientUsdtIncomeBalance: "USDT 收益余额不足",
      usdtExchangeSucceeded: "USDT 兑换成功",
    },
    en: {
      withdraw: "Withdraw",
      exchange: "Exchange",
      records: "Records",
      from: "From",
      to: "To",
      all: "All",
      available: "Available",
      price: "Price",
      fee: "Fee",
      amount: "Amount",
      usdtToContract: "USDT to Contract",
      autoHint: "When auto-transfer is on, mining-pool earnings are automatically converted to USDT",
      autoExchangeFailed: "Failed to toggle auto exchange",
      getConfigFailed: "GetConfig failed",
      getUserInfoFailed: "GetUserInfo failed",
      getUserAssetsFailed: "GetUserAssets failed",
      invalidEthAmount: "Invalid USDC amount",
      insufficientEthBalance: "Insufficient USDC balance",
      ethExchangeSucceeded: "USDC exchange succeeded",
      invalidTrxAmount: "Invalid TRX amount",
      insufficientTrxBalance: "Insufficient TRX balance",
      trxExchangeSucceeded: "TRX exchange succeeded",
      invalidWithdrawAmount: "Invalid withdraw amount",
      insufficientUsdtBalance: "Insufficient USDT balance",
      amountMustBeGte: "Amount must be >=",
      amountMustBeLte: "Amount must be <=",
      withdrawSucceeded: "Withdraw succeeded",
      invalidUsdtAmount: "Invalid USDT amount",
      insufficientUsdtIncomeBalance: "Insufficient USDT income balance",
      usdtExchangeSucceeded: "USDT exchange succeeded",
    },
  },
  data() {
    return {
      action: {
        withdrawValue: "",
        exchangeValueErc: "",
        exchangeValueTrc: "",
        active: 0,
        exchangeContract: "",
      },
      btnLoading: false,
      type: "1",
      message: "",
      checked: false,

      config: {
        isEnableErc: 1,
        isEnableTrc: 1,
        ethRate: 2107,
        trxRate: 0.074,
        usdcRate: 1,
        minAmount: 0,
        maxAmount: 0,
        usdtDecimal: 2,
        withdrawFee: {
          ERC20: [{ minAmount: 0, fees: 0 }],
          TRC20: [{ minAmount: 0, fees: 0 }],
        },
        drawIsAuthorize: false,
        pledgeWithdrawal: false,
      },
      userInfo: {
        address: "",
        autoExchange: 0,
        pledge: false,
      },
      assets: {
        USDC: { availableContractTotal: 0, availableIncomeTotal: 0, balance: 0 },
        TRX: { availableContractTotal: 0, availableIncomeTotal: 0, balance: 0 },
        USDT: { availableContractTotal: 0, availableIncomeTotal: 0, balance: 0 },
      },
      withdrawFeePercent: 0,
    };
  },
  computed: {
    fullAddress() {
      return this.userInfo.address || localStorage.getItem("U_ADDRESS") || sessionStorage.getItem("ADDRESS") || "";
    },
    displayAddress() {
      if (!this.fullAddress) return "0xD6990DBC6a6F8a...";
      if (this.fullAddress.length <= 18) return this.fullAddress;
      return `${this.fullAddress.slice(0, 14)}...`;
    },
    sourceCoin() {
      return this.action.active === 1 ? "TRX" : this.$quote;
    },
    sourceIcon() {
      return this.action.active === 1 ? "/recovered-assets/trx_icon.png" : "/recovered-assets/usdc_logo.svg";
    },
    sourceAvailable() {
      return this.action.active === 1 ? this.exchangeAvailableTrc : this.exchangeAvailableErc;
    },
    sourceValue: {
      get() {
        return this.action.active === 1 ? this.action.exchangeValueTrc : this.action.exchangeValueErc;
      },
      set(v) {
        if (this.action.active === 1) {
          this.action.exchangeValueTrc = v;
          return;
        }
        this.action.exchangeValueErc = v;
      },
    },
    destinationValue() {
      if (this.action.active === 1) return this.calcTRXToUSDT;
      return this.calcETHToUSDT;
    },
    priceText() {
      if (this.action.active === 1) {
        return `1TRX ≈ ${toNum(this.config.trxRate).toFixed(6)} USDT`;
      }
      return `1${this.$quote} ≈ ${toNum(this.config.usdcRate).toFixed(2)} USDT`;
    },
    exchangeAvailableErc() {
      const a = this.assets[this.$quote] || this.assets.USDC;
      return this.type === "1" ? toNum(a.availableContractTotal) : toNum(a.availableIncomeTotal);
    },
    exchangeAvailableTrc() {
      return this.type === "1" ? toNum(this.assets.TRX.availableContractTotal) : toNum(this.assets.TRX.availableIncomeTotal);
    },
    withdrawAvailable() {
      return this.type === "1" ? toNum(this.assets.USDT.availableContractTotal) : toNum(this.assets.USDT.availableIncomeTotal);
    },
    exchangeContractUSDTAvailable() {
      return toNum(this.assets.USDT.availableIncomeTotal);
    },
    calcETHToUSDT() {
      return (toNum(this.config.usdcRate) * toNum(this.action.exchangeValueErc)).toFixed(6);
    },
    calcTRXToUSDT() {
      return (toNum(this.config.trxRate) * toNum(this.action.exchangeValueTrc)).toFixed(6);
    },
    amountLength() {
      if (!String(this.action.withdrawValue).includes(".")) return 20;
      return String(this.action.withdrawValue).split(".")[0].length + Number(this.config.usdtDecimal || 2) + 1;
    },
    calcWithdrawFee() {
      const amount = toNum(this.action.withdrawValue);
      const feeSet = this.userInfo.coin === "TRX" ? this.config.withdrawFee.TRC20 : this.config.withdrawFee.ERC20;

      if (!Array.isArray(feeSet) || feeSet.length === 0) {
        this.withdrawFeePercent = 0;
        return "0.00";
      }

      let hit = feeSet[0];
      feeSet.forEach((item) => {
        if (amount >= toNum(item.minAmount)) hit = item;
      });

      this.withdrawFeePercent = toNum(hit.fees);
      return (amount * (this.withdrawFeePercent / 100)).toFixed(2);
    },
  },
  watch: {
    "$route.query.type": {
      handler() {
        this.applyRouteTab();
      },
    },
  },
  mounted() {
    this.applyRouteTab();
    this.bootstrap();
  },
  methods: {
    setMessage(msg) {
      this.message = msg || "";
    },
    numFormat(v, decimals = 2) {
      return toNum(v).toFixed(decimals);
    },
    applyRouteTab() {
      const type = Number(this.$route.query.type);
      if (type === 0 || type === 1 || type === 2 || type === 3) {
        this.action.active = type;
      }
    },
    switchTab(tab) {
      this.action.active = tab;
      this.clear();
    },
    fillAllCurrent() {
      if (this.action.active === 1) {
        this.onRedeemAllTrc();
        return;
      }
      this.onRedeemAllErc();
    },
    async onToggleAutoExchange() {
      const prev = this.checked;
      this.checked = !prev;
      try {
        await changeAutoExchange(this.sourceCoin);
      } catch (err) {
        this.checked = prev;
        this.setMessage((err && err.message) || this.$t("autoExchangeFailed"));
      }
    },
    async onSubmit() {
      if (this.action.active === 1) {
        await this.onExchangeTrc();
        return;
      }
      if (this.action.active === 3) {
        await this.onWithdraw();
        return;
      }
      if (this.action.active === 2) {
        await this.exchangeContractByUsdt();
        return;
      }
      await this.onExchangeErc();
    },
    normalizeConfig(raw) {
      if (!raw || typeof raw !== "object") return;
      this.config = {
        ...this.config,
        ...raw,
        ethRate: toNum(raw.ethRate) || this.config.ethRate,
        trxRate: toNum(raw.trxRate) || this.config.trxRate,
        usdcRate: toNum(raw.usdcRate) || this.config.usdcRate,
        withdrawFee: raw.withdrawFee || this.config.withdrawFee,
      };
    },
    normalizeAssets(raw) {
      // /api/user/wallet 返回 data 为数组：[{ coin, balance, pledge_balance, total_balance }]
      const next = {
        USDC: { availableContractTotal: 0, availableIncomeTotal: 0, balance: 0 },
        TRX: { availableContractTotal: 0, availableIncomeTotal: 0, balance: 0 },
        USDT: { availableContractTotal: 0, availableIncomeTotal: 0, balance: 0 },
      };

      const list = Array.isArray(raw) ? raw : raw && Array.isArray(raw.list) ? raw.list : [];
      list.forEach((x) => {
        const coin = x && x.coin;
        if (!coin || !next[coin]) return;
        const bal = toNum(x.balance);
        next[coin] = {
          balance: bal,
          availableContractTotal: bal,
          availableIncomeTotal: bal,
        };
      });

      this.assets = next;
    },
    async bootstrap() {
      try {
        const cfg = await getConfig(document.domain);
        this.normalizeConfig(cfg);
      } catch (err) {
        this.setMessage((err && err.message) || this.$t("getConfigFailed"));
      }

      try {
        const info = await getUserInfo();
        this.userInfo = { ...this.userInfo, ...(info || {}) };
        this.checked = !!toNum(this.userInfo.autoExchange);
      } catch (err) {
        this.setMessage((err && err.message) || this.$t("getUserInfoFailed"));
      }

      await this.reloadAssets();
    },
    async reloadAssets() {
      try {
        const assets = await getUserAssets();
        this.normalizeAssets(assets);
      } catch (err) {
        this.setMessage((err && err.message) || this.$t("getUserAssetsFailed"));
      }
    },
    async onExchangeErc() {
      const amount = toNum(this.action.exchangeValueErc);
      if (amount <= 0) {
        this.setMessage(this.$t("invalidEthAmount"));
        return;
      }
      if (amount > this.exchangeAvailableErc) {
        this.setMessage(this.$t("insufficientEthBalance"));
        return;
      }

      this.btnLoading = true;
      try {
        await orderExchange({ amount, coin: this.$quote, type: this.type });
        this.action.exchangeValueErc = "";
        await this.reloadAssets();
        this.setMessage(this.$t("ethExchangeSucceeded"));
      } catch (err) {
        this.setMessage((err && err.message) || String(err));
      } finally {
        this.btnLoading = false;
      }
    },
    async onExchangeTrc() {
      const amount = toNum(this.action.exchangeValueTrc);
      if (amount <= 0) {
        this.setMessage(this.$t("invalidTrxAmount"));
        return;
      }
      if (amount > this.exchangeAvailableTrc) {
        this.setMessage(this.$t("insufficientTrxBalance"));
        return;
      }

      this.btnLoading = true;
      try {
        await orderExchange({ amount, coin: "TRX", type: this.type });
        this.action.exchangeValueTrc = "";
        await this.reloadAssets();
        this.setMessage(this.$t("trxExchangeSucceeded"));
      } catch (err) {
        this.setMessage((err && err.message) || String(err));
      } finally {
        this.btnLoading = false;
      }
    },
    async onWithdraw() {
      const amount = toNum(this.action.withdrawValue);
      if (amount <= 0) {
        this.setMessage(this.$t("invalidWithdrawAmount"));
        return;
      }
      if (amount > this.withdrawAvailable) {
        this.setMessage(this.$t("insufficientUsdtBalance"));
        return;
      }
      if (toNum(this.config.minAmount) > 0 && amount < toNum(this.config.minAmount)) {
        this.setMessage(`${this.$t("amountMustBeGte")} ${this.config.minAmount}`);
        return;
      }
      if (toNum(this.config.maxAmount) > 0 && amount > toNum(this.config.maxAmount)) {
        this.setMessage(`${this.$t("amountMustBeLte")} ${this.config.maxAmount}`);
        return;
      }

      this.btnLoading = true;
      try {
        // 该页提现固定走 USDT（可用余额、手续费、币种标识都是 USDT）
        await orderWithdraw(amount, "USDT");
        this.action.withdrawValue = "";
        await this.reloadAssets();
        this.setMessage(this.$t("withdrawSucceeded"));
      } catch (err) {
        this.setMessage((err && err.message) || String(err));
      } finally {
        this.btnLoading = false;
      }
    },
    async exchangeContractByUsdt() {
      const amount = toNum(this.action.exchangeContract);
      if (amount <= 0) {
        this.setMessage(this.$t("invalidUsdtAmount"));
        return;
      }
      if (amount > this.exchangeContractUSDTAvailable) {
        this.setMessage(this.$t("insufficientUsdtIncomeBalance"));
        return;
      }

      this.btnLoading = true;
      try {
        await exchangeContractByUSDT(amount);
        this.action.exchangeContract = "";
        await this.reloadAssets();
        this.setMessage(this.$t("usdtExchangeSucceeded"));
      } catch (err) {
        this.setMessage((err && err.message) || String(err));
      } finally {
        this.btnLoading = false;
      }
    },
    onRedeemAllErc() {
      this.action.exchangeValueErc = String(this.exchangeAvailableErc || 0);
    },
    onRedeemAllTrc() {
      this.action.exchangeValueTrc = String(this.exchangeAvailableTrc || 0);
    },
    onTotalBalance() {
      this.action.withdrawValue = String(this.withdrawAvailable || 0);
    },
    onTotalUsdt() {
      this.action.exchangeContract = String(this.exchangeContractUSDTAvailable || 0);
    },
    clear() {
      this.action.withdrawValue = "";
      this.action.exchangeValueErc = "";
      this.action.exchangeValueTrc = "";
      this.action.exchangeContract = "";
      this.message = "";
    },
  },
};
</script>

<style scoped>
.trade-page {
  min-height: 100vh;
  padding-bottom: 84px;
  background: transparent;
}

.header {
  background: transparent;
}

.header-row {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  box-sizing: border-box;
}

.lang-btn {
  border: 0;
  background: transparent;
  color: #9aa3b2;
  font-size: 14px;
  padding: 0;
  display: flex;
  align-items: center;
}

.lang-btn::after {
  content: "▼";
  font-size: 10px;
  margin-left: 6px;
  color: #5b6474;
}

.top-title {
  margin: 0;
  font-size: 30px;
  line-height: 1;
  font-weight: 700;
  color: #eef1f6;
}

.addr-pill {
  width: 150px;
  height: 36px;
  border: 1px solid var(--pool-line);
  border-radius: 10px;
  background: var(--pool-glass);
  color: var(--pool-muted);
  font-size: 13px;
  line-height: 36px;
  text-align: left;
  padding: 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.trade-content {
  padding: 14px 14px 0;
}

.trade-tabs {
  margin-top: 4px;
  background: var(--pool-glass);
  border: 1px solid var(--pool-line);
  border-radius: 14px;
  padding: 0 6px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.tab-item {
  position: relative;
  height: 50px;
  border: 0;
  background: transparent;
  font-size: 22px;
  color: var(--pool-muted);
  border-radius: 10px;
  transition: color 0.2s ease, background 0.2s ease;
}

.tab-item.active {
  color: #04121a;
  background: var(--pool-grad);
  box-shadow: 0 12px 26px -14px rgba(51, 226, 199, 0.55);
}

.tab-item.active::after {
  content: "";
  position: absolute;
  left: 30%;
  right: 30%;
  bottom: 0;
  height: 0;
  border-radius: 3px;
  background: transparent;
}

.msg {
  margin: 10px 8px 0;
  color: var(--pool-bad);
  font-size: 12px;
  text-align: left;
}

.actions-con {
  width: 100%;
  margin: 10px auto 0;
  border-radius: var(--pool-r);
  background: var(--pool-glass);
  border: 1px solid var(--pool-line);
  box-shadow: 0 20px 40px -34px rgba(0, 0, 0, 0.9);
  padding: 16px 14px 14px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.actions-con::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(160deg, rgba(255, 255, 255, 0.14), transparent 40%);
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.records-btn {
  position: absolute;
  right: 14px;
  top: 18px;
  border: 0;
  background: transparent;
  color: var(--pool-muted);
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  z-index: 1;
}

.record-icon {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  stroke-width: 1.8;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.card-title {
  margin: 8px 0 20px;
  color: var(--pool-text);
  font-size: 24px;
  font-weight: 700;
  position: relative;
  z-index: 1;
}

.input-wrap {
  background: rgba(0, 0, 0, 0.22);
  border: 1px solid var(--pool-line);
  border-radius: 14px;
  padding: 14px 10px;
  position: relative;
  z-index: 1;
}

.input-wrap + .input-wrap {
  margin-top: 12px;
}

.flex-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.prefix {
  min-width: 32px;
  text-align: left;
  color: var(--pool-muted);
  font-size: 17px;
}

.field {
  margin-right: 2px;
  flex: 1;
}

.amount-input {
  width: 100%;
  border: 0;
  background: transparent;
  font-size: 17px;
  color: var(--pool-text);
}

.amount-input::placeholder {
  color: var(--pool-faint);
}

.amount-input.disabled {
  color: var(--pool-faint);
}

.all-btn {
  border: 0;
  background: transparent;
  color: var(--pool-teal);
  font-weight: 700;
  font-size: 18px;
  padding: 0 2px;
}

.coin-wrap {
  min-width: 90px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 20px;
  color: var(--pool-text);
}

.coin-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.speator {
  margin: 18px 0;
  color: var(--pool-teal);
  font-size: 28px;
  font-weight: 700;
  position: relative;
  z-index: 1;
}

.price-text {
  margin-top: 16px;
  text-align: right;
  color: var(--pool-text);
  font-size: 20px;
  font-weight: 700;
  position: relative;
  z-index: 1;
}

.fee-tip {
  margin-top: 14px;
  font-size: 14px;
  color: var(--pool-muted);
  text-align: left;
  position: relative;
  z-index: 1;
}

.switch-line {
  margin-top: 20px;
  padding-left: 2px;
  text-align: left;
}

.switch {
  position: relative;
  display: inline-block;
  width: 88px;
  height: 44px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: var(--pool-glass-2);
  transition: 0.2s;
  border-radius: 24px;
  box-shadow: inset 0 0 0 1px var(--pool-line);
}

.slider::before {
  position: absolute;
  content: "";
  height: 36px;
  width: 36px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  transition: 0.2s;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}

input:checked + .slider {
  background: var(--pool-grad);
  box-shadow: inset 0 0 0 1px transparent;
}

input:checked + .slider::before {
  transform: translateX(44px);
}

.submit-btn {
  margin-top: 22px;
  width: 100%;
  border: 0;
  border-radius: 40px;
  height: 58px;
  color: #04121a;
  background: var(--pool-grad);
  font-size: 24px;
  font-weight: 700;
  box-shadow: 0 16px 34px -14px rgba(51, 226, 199, 0.55);
}

.submit-btn:disabled {
  opacity: 0.7;
}

.hint {
  margin: 18px 0 0;
  text-align: left;
  color: var(--pool-muted);
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 430px) {
  .tab-item {
    font-size: 15px;
    height: 44px;
  }

  .card-title {
    font-size: 18px;
  }

  .amount-input,
  .coin-wrap {
    font-size: 14px;
  }

  .coin-wrap {
    min-width: 72px;
    gap: 6px;
  }

  .price-text {
    font-size: 14px;
  }

  .submit-btn {
    height: 46px;
    font-size: 16px;
  }
}
</style>
